import React, { useEffect, useState, useRef } from "react";
import QuoteRatio from "../SmcLife/Images/claim-satelment-ratio-icon.svg";
import DownloadBroche from "../SmcLife/Images/Icon-download.svg";
import { useHistory } from "react-router-dom";
import "../SmcLife/IndexLife.css";
import { FaArrowRightLong } from "react-icons/fa6";
import CircleLoader from "./UtilityComponents/CircleLoader";
import { convertIntoLakh, CommaSeprator } from "./UtilityComponents/UtilityFunction";
import axios from "axios";

const LifeQuotationCard = ({ quoteValue, Data, occData, QCardLoader, selectedQuoteKey, setSelectedQuoteKey, IsFromHouseWifeComponent, gstEnable, RiderDetails, QR, handleAutoPay, Quotes, hideQuotes }) => {
    //console.log(RiderDetails, "wwwww")
    const history = useHistory();
    const [premiumFreq, setPremiumFreq] = useState(quoteValue?.PremiumFrequency);
    const houseWife = IsFromHouseWifeComponent ? true : false;
 
    const handleClick = (quoteValue) => {
        setSelectedQuoteKey(quoteValue.TransKey);

        const reqBody = {
            EnquiryNo: quoteValue.EnquiryNo,
            TransKey: quoteValue.TransKey,
        }

        const model = {
            URL: "SaveQuote",
            PostString: JSON.stringify(reqBody),
        }

        axios.post("central/centralcall/CallReqWithHeader", model)
            .then((res) => {
                if (res.data.StatusCode === 200) {
                    const params = { quote: quoteValue, data: Data, OccData: occData, QuoteRequest: QR, IsFromHouseWifeComponent: houseWife };
                    history.push({
                        pathname: "/SmcLifeProposal",
                        state: params,
                    });
                } else {
                    alert("Errors in saving");
                }
            })
            .catch((err) => {
                console.error(err);
            })


    };
    const getClassName = (premium) => {
        //console.log(premium, "get preee")
        return premium > 0 ? "premium-available" : "premium-na";
    }


    useEffect(() => {

        if (quoteValue.PremiumFrequency === "Y") {
            setPremiumFreq("Yearly")
        }
        else if (quoteValue.PremiumFrequency === "M") {
            setPremiumFreq("Monthly")
        }
        else if (quoteValue.PremiumFrequency === "Q") {
            setPremiumFreq("Quarterly")
        }
        else if (quoteValue.PremiumFrequency === "H") {
            setPremiumFreq("Half-Yearly")
        }
        else if (quoteValue.PremiumFrequency === "S") {
            setPremiumFreq("One Time")
        }
        else {
            console.error("Error in getting premium frequency");
        }
    }, [quoteValue.PremiumFrequency])


    const [isOverflow, setIsOverflow] = useState(false);
    const ulRef = useRef(null);

    useEffect(() => {
        const checkOverflow = () => {
            if (ulRef.current) {
                // Fix the typo in scrollWidth
                const hasOverflow = ulRef.current.scrollWidth > ulRef.current.clientWidth;
                setIsOverflow(hasOverflow);
            }
        };

        // Check on mount and window resize
        checkOverflow();
        window.addEventListener("resize", checkOverflow);

        return () => window.removeEventListener("resize", checkOverflow);
    }, []);


    return (
        <>

            <div className="quotescardsMargine">
                <div className="QuotetionBox LifeQuoteUI">
                    {Quotes?.length > 1 && <div className="IconContainer">
                        <small className="hideIcon_EyeInfo" onClick={() => hideQuotes(quoteValue?.TransKey)} ><i className="fas fa-minus-circle"></i><span></span></small>
                    </div>}
                    <div className="col-md-12">
                        <div className="LI_CUST_Head">
                            {QCardLoader ? (
                                <p>
                                    <strong>Plan :</strong>
                                </p>
                            ) : (
                                <p>
                                    <strong>{quoteValue?.PlanName}</strong>
                                </p>
                            )}
                        </div>
                    </div>
                    <div className="QuoteDetailBox">
                        <div>
                            {QCardLoader ? (
                                <span className="LoaderImg"></span>
                            ) : (
                                <img
                                    src={quoteValue?.LogoUrl}
                                    className="HdfcLogo"
                                    alt={quoteValue?.CompanyName}
                                />
                            )}
                        </div>
                        <div className="mb-0 Quote_Value">
                            <span>Cover till Age</span>
                            <p className="mb-0 Quote_Value">
                                <strong>
                                    {" "}
                                    {QCardLoader ? (
                                        <span className="LoaderImg"></span>
                                    ) : (
                                        Data
                                    )}{" "}
                                    Years
                                </strong>
                            </p>
                        </div>
                        <div className="mb-0 Quote_Value">
                            <span className="">Coverage</span>
                            <p className="mb-0 Quote_Value">
                                <strong>
                                    ₹
                                    {QCardLoader ? (
                                        <span className="LoaderImg"></span>
                                    ) : (
                                        convertIntoLakh(quoteValue?.SumInsured)
                                    )}{" "}
                                </strong>
                            </p>
                        </div>
                        {/* <PlansDetailbtn /> */}
                        {/*<div className="planDCircle mb-0">*/}
                        {/*    <p className="mb-0">Plan Details</p>*/}
                        {/*</div>*/}
                        <div className="mb-0">
                            <button
                                className="QuoteBtn"
                                disabled={QCardLoader}
                                onClick={() => handleClick(quoteValue)}
                            >
                                {(QCardLoader || selectedQuoteKey=== quoteValue.TransKey) ? (
                                    <CircleLoader />
                                ) : (
                                    <>
                                        {/*<small className="PremiumBuyNow">Buy Now</small>*/}
                                        <span className="buyme ng-binding">
                                                ₹{CommaSeprator(quoteValue ? (!gstEnable ? quoteValue.NetPremium : quoteValue.TotalPremium) : "")}&nbsp; <span><i className="fa fa-chevron-right"></i></span>
                                        </span>
                                    </>
                                )}
                            </button>

                            <div className="PerMonthVal">
                                <span>
                                    {premiumFreq}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="Life_Cust_Claim_List Claim_settlement1">
                        <img
                            src={QuoteRatio}
                            className="SettleQuoteR mx-1"
                            alt="quotecratio"
                        />
                        <span className="Cust_Claim-Val">
                            {quoteValue?.ClaimSettlementRatio}% Claim Settlement Ratio
                        </span>
                    </div>
                    {RiderDetails?.ridersAndBenefit && <div className="rider_cards">
                        {isOverflow && (<div className="shadow_div"></div>)}
                        <ul ref={ulRef} className="ScrollableStrip">
                            {Object.keys(Object.fromEntries(Object.entries(RiderDetails.ridersAndBenefit).filter(([key, value]) => value === true))).map(r => {
                                switch (r) {
                                    case "IsAccidentalDeathBenefit":
                                        return <li className={getClassName(quoteValue?.AccidentalDeathBenefitPremium)}>Accidental Death Benefit:
                                            <span>{quoteValue?.AccidentalDeathBenefitPremium > 0 ? `₹${quoteValue?.AccidentalDeathBenefitPremium}` : "NA"}</span></li>
                                    case "IsPremiumProtectionBenefit":
                                        return <li className={getClassName()}>Return of Premium Benefit:
                                            <span>{quoteValue?.PremiumProtectionBenefitPremium > 0 ? `₹${quoteValue?.PremiumProtectionBenefitPremium}` : "NA"}</span></li>
                                    case "IsPremiumWaiverBenefit":
                                        return <li className={getClassName(quoteValue?.PremiumWaiverBenefitPremium)}>Waiver of Premium Benefit:
                                            <span>{quoteValue?.PremiumWaiverBenefitPremium > 0 ? `₹${quoteValue?.PremiumWaiverBenefitPremium}` : "NA"}</span></li>
                                    case "IsAccidentalDisabilityRider":
                                        return <li className={getClassName(quoteValue?.RiderAccidentalDisabilityPremium)}>Accidental Disability Rider:
                                            <span>{quoteValue?.RiderAccidentalDisabilityPremium > 0 ? `₹${quoteValue?.RiderAccidentalDisabilityPremium}` : "NA"}</span></li>
                                    case "IsCriticalIllnessRider":
                                        return <li className={getClassName(quoteValue?.RiderCriticalIllnessPremium)}>Critical Illness Rider:
                                            <span>{quoteValue?.RiderCriticalIllnessPremium > 0 ? `₹${quoteValue?.RiderCriticalIllnessPremium}` : "NA"}</span></li>
                                    case "IsTerminalIllnessRider":
                                        return <li className={getClassName(quoteValue?.RiderTerminalIllnessPremium)}>Cancer Care Rider:
                                            <span>{quoteValue?.RiderTerminalIllnessPremium > 0 ? `₹${quoteValue?.RiderTerminalIllnessPremium}` : "NA"}</span></li>
                                    case "IsPersonalAccidentRider":
                                        return <li className={getClassName(quoteValue?.RiderPersonalAccidentPremium)}>Personal Accident Cover:
                                            <span>{quoteValue?.RiderPersonalAccidentPremium > 0 ? `₹${quoteValue?.RiderPersonalAccidentPremium}` : "NA"}</span></li>
                                    case "IsAccidentalDeathRider":
                                        return <li className={getClassName(quoteValue?.RiderAccidentalDeathPremium)}>Accidental Death Cover:
                                            <span>{quoteValue?.RiderAccidentalDeathPremium > 0 ? `₹${quoteValue?.RiderAccidentalDeathPremium}` : "NA"}</span></li>
                                    case "IsHospitalCareRider":
                                        return <li className={getClassName(quoteValue?.RiderHospitalCarePremium)}>Hospital Care Rider:
                                            <span>{quoteValue?.RiderHospitalCarePremium > 0 ? `₹${quoteValue?.RiderHospitalCarePremium}` : "NA"}</span></li>
                                    default:
                                        return null;
                                }
                            })
                            }
                        </ul>
                    </div>}
                    <div className="LI_CUST_Bottom LI_Bottom_Shadow">

                        <div className="Life_Cust_Claim_List Claim_settlement2">
                            <img
                                src={QuoteRatio}
                                className="SettleQuoteR mx-1"
                                alt="quotecratio"
                            />
                            <span className="Cust_Claim-Val">
                                {quoteValue?.ClaimSettlementRatio}% Claim Settlement Ratio
                            </span>
                        </div>
                        
                        {/* <div className="Life_Cust_Claim_List">
                            <span className="QuoteTSave">Tax savings ₹ 2.57 Lakh</span>
                            <img
                            src={InfoCircle}
                            className="SettleQuoteR mxs-1"
                            alt="infocircle"
                            />
                            </div> */}
                        <div className="Life_Cust_Claim_List Life_Cust_Down_Broche">
                            <a href={quoteValue?.Brochure} target="_blank">
                                <span className="QuoteTSave">Brochure</span>
                            </a>
                            <img
                                src={DownloadBroche}
                                className="SettleQuoteR mx-1"
                                alt="downloadbrochure"
                            />
                        </div>
                        {quoteValue?.BIPath ? (
                            <div className="Life_Cust_Claim_List Life_Cust_Down_Broche">
                                <a href={quoteValue?.BIPath} target="_blank">
                                    <span className="QuoteTSave">Benefits Illustration</span>
                                </a>
                                <img
                                    src={DownloadBroche}
                                    className="SettleQuoteR mx-1"
                                    alt="downloadbrochure"
                                />
                            </div>) : ""}
                        {quoteValue.InsurerId === 156 && <div className="autopay_Payment">
                            <label> 
                                <input type="checkbox" checked={quoteValue?.IsAutoPay} onChange={() => handleAutoPay(quoteValue.IsAutoPay ? false:true) } />
                                <span> Autopay Payment</span>
                            </label>
                            <p className="">Get {quoteValue?.IsAutoPayDiscount}% discount</p>
                        </div>}
                    </div>
                </div>
            </div>
        </>
    );
};

export default LifeQuotationCard;
